import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import { State } from '../../../store'
import _ from 'lodash'
import FormComponentState from './states'

const actions: ActionTree<FormComponentState, State> = {
  updateAttr(
    { commit, state }: ActionContext<FormComponentState, State>,
    data: {
      formName: string,
      attrName: string,
      value: any,
    },
  ): void {
    if (!_.isEqual(state.data, data.value)) {
      commit(mutationType.UPDATE_VALUE, data)
    }
  },
  init(
    { commit, state }: ActionContext<FormComponentState, State>,
    data: {
      formName: string,
      value: any,
    },
  ) {
    commit(mutationType.INIT_FORM, data)
  },
  reset(
    { commit, state }: ActionContext<FormComponentState, State>,
    formName: string,
  ) {
    commit(mutationType.REMOVE_FORM, formName)
  },
}

export default actions
